@use 'ui/styles/core-tokens' as core;

.caption {
  display: flex;
  gap: 3px;
}
